import { useMutation } from '@tanstack/react-query';
import { Services } from '@prisma/client';
import { archiveBusinessService } from '../../services/business';
import useUser from '../global/useUser';

interface ArchiveServiceOptions {
  onSuccess?: (service: Services) => void | Promise<void>;
  onError?: () => void | Promise<void>;
}

function useArchiveService({ onSuccess, onError }: ArchiveServiceOptions = {}) {
  const { user } = useUser();

  const businessId = user?.business?.id;

  return useMutation({
    mutationFn: async (serviceId: number) => {
      if (!serviceId || !businessId) throw new Error('Invalid parameters');

      const service = await archiveBusinessService(businessId, serviceId);

      return service;
    },
    onSuccess,
    onError,
  });
}

export default useArchiveService;
